import { render } from "./InputTextarea.vue?vue&type=template&id=60407abb&scoped=true&bindings={\"id\":\"props\",\"placeholder\":\"props\",\"value\":\"props\",\"name\":\"props\",\"error\":\"props\",\"req\":\"props\",\"updateValue\":\"setup\",\"state\":\"setup\",\"updateState\":\"setup\"}"
import script from "./InputTextarea.vue?vue&type=script&lang=ts"
export * from "./InputTextarea.vue?vue&type=script&lang=ts"

import "./InputTextarea.vue?vue&type=style&index=0&id=60407abb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-60407abb"

export default script